import { Config, ConfigType } from "../game/Config";
import * as PIXI from 'pixi.js'
import { Loader } from "./Loader";
import { ScenesManager } from "./ScenesManager";

import { classicCrash, ClassicCrash } from "./ClassicCrash";
import { SplashManager } from "./SplashManager";
import { Profiler } from "./Profiler";
import { PostMessageHandler } from "./PostMessagesManager";
import { hideElement, showElement } from "@utils/helpers";
 

class Application {

    config: ConfigType
    app: PIXI.Application
    // loader: Loader
    scenes: ScenesManager
    classicCrash: ClassicCrash
 
    splashManager = new SplashManager(Config)
    profiler: Profiler
    postMessagesManager: PostMessageHandler
    constructor(config: ConfigType) {
        //game config
        this.config = config
        //app instance
        this.app = new PIXI.Application()
        //loader instance
        // this.loader = new Loader(this.config)
        //scene manager instance
        this.scenes = new ScenesManager();
        //classic crash
        this.classicCrash = classicCrash
        this.postMessagesManager = new PostMessageHandler()
        this.profiler = new Profiler()


    }


    async run() {
        await classicCrash.buildClient()
        // console.log('run app')
        //append app to canvas container
        const canvasContainer = document.getElementById('canvas') as HTMLDivElement
        await this.app.init({ antialias: true, resolution: window.devicePixelRatio || 1, autoDensity: true, resizeTo: canvasContainer, background: 0xffffff })
        canvasContainer.appendChild(this.app.canvas);
        //load assets  
        // await this.loader.preload()
        //start classic crash
        await classicCrash.start(this.scenes)
        await classicCrash.connect()
        //start scenes
        this.start()






        //append scene manager to app 
        this.app.stage.addChild(this.scenes.container);
    }


   

    start() {

        this.scenes.start("Game")
    }


    getWidth() {
        return this.app.renderer.width;
    }

    getHeight() {
        return this.app.renderer.height;
    }

    getScreenHeight() {
        return window.innerHeight;
    }

    getScreenWidth() {
        return window.innerWidth;
    }

    resize() {
        const canvasContainer = document.getElementById('canvas') as HTMLDivElement;
        const newWidth = canvasContainer.clientWidth
        const newHeight = canvasContainer.clientHeight

        if (canvasContainer) {
            this.app.renderer.resize(newWidth, newHeight);
            this.scenes.scene?.resize(newWidth, newHeight)
            // this.scenes.start('Game')

        }
        this.splashManager.resize()



    }

    gameLoad(started: boolean){
        const loader = document.getElementById("game-Loader")
        if(!loader) return
        if(started){
            showElement(loader)
        }else{
            hideElement(loader)

        }
    }

    get configManager(){
        return App.classicCrash.configManager
    }


    get sdk(){
        return App.classicCrash.classicCrash
    }
}

export const App = new Application(Config) 